import styled from "styled-components";

import { breakpoints } from "../../../constants/breakpoints";

export const Wrap = styled.div`
  /* Mobile / default */

  /* Tablet breakpoint */
  @media only screen and (min-width: ${breakpoints.tablet}px) {
  }

  /* Desktop breakpoint */
  @media only screen and (min-width: ${breakpoints.desktopWide}px) {
  }
`;
